<div class="sol-badge-container" [class.sol-badge-inset]="inset$()">
  <span
    class="sol-badge-content"
    [class.sol-badge-content-cutout]="cutout$()"
    [class.sol-badge-content-cutout-dot]="cutout$() && dotVisible$()"
    [class.sol-badge-content-cutout-count]="cutout$() && countVisible$()"
  >
    <ng-content />
  </span>
  @if (visible$()) {
    <span
      class="sol-badge-indicator"
      [class.sol-badge-indicator-dot]="dotVisible$()"
      [class.sol-badge-indicator-count]="countVisible$()"
      [style.background-color]="backgroundColor$()"
    >
      {{ displayCount$() }}
    </span>
  }
</div>
